import { application } from "./application"
import ClientPositionsController from "./client_positions_controller"
import PositionSelectController from "./position_select_controller"
application.register("client-positions", ClientPositionsController) 
application.register("position-select", PositionSelectController) 